var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBillLineDocument = function SvgBillLineDocument(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.667 18.333H3.333A.833.833 0 0 1 2.5 17.5v-15a.833.833 0 0 1 .833-.833h13.334a.833.833 0 0 1 .833.833v15a.833.833 0 0 1-.833.833Zm-.834-1.666V3.332H4.167v13.333h11.666ZM6.667 7.5h6.666v1.666H6.667V7.5Zm0 3.333h6.666V12.5H6.667v-1.667Z",
    fill: "#999FB4"
  })));
};
export default SvgBillLineDocument;